import React, { useState } from 'react';
import { Linkedin, Heart, Brain, Lightbulb, Sparkles, BookOpen, Gamepad2, GraduationCap, Smartphone, X } from 'lucide-react';

const mentalHealthTeam = [
  {
    id: 1,
    name: "Nazreen Ghafoerkhan",
    role: "Director",
    title: "Founder & Director",
    image: "https://customer-assets.emergentagent.com/job_69ab5d25-c287-408f-a49d-e502a7f317ab/artifacts/017xkdnl_naz.jpeg",
    linkedin: "https://www.linkedin.com/in/ghafoerkhan-nazreen-67b8b385/",
    bio: null
  },
  {
    id: 2,
    name: "Vanessa Nank",
    role: "Director",
    title: "School Psychologist and Author",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/pcth5wec_Vanessa%20Nank%27s%20Headshot%20%281%29.jpg",
    linkedin: null,
    bio: [
      "Inspired by her love for kids and hoping to play a supportive role in their lives, Vanessa started her career in the human services field as a Career Counselor for a nonprofit in Long Island, New York. She later went on to take on roles like Case Manager and Family Mediator working with homeless adolescents. She also worked as an educational advocate for kids in foster care. Working with youth along the years helped to solidify her decision in becoming a School Psychologist. Vanessa became a School Psychologist in 2014. She worked both in the Yonkers Public School district in New York and the Collier County school district in Florida.",
      "As she worked with students of various cultures, backgrounds, experiences, and beliefs, she began to see a need for mindfulness education. In 2017, she wrote Mindful Me, a children's book about the benefits of mindful living.",
      "Through her work with youth, Vanessa seeks to promote social/emotional learning, mindfulness, executive function skills, and self-care. Her goal is to encourage self-awareness and self-worth to help youth discover their highest potential. Vanessa is currently serving the Fort Myers, Florida area as a licensed school psychologist in her private practice, Present Mind LLC."
    ]
  },
  {
    id: 3,
    name: "Maribel Mesina-Geib",
    role: "Director",
    title: "Registered Mental Health Counselor Intern",
    image: "https://customer-assets.emergentagent.com/job_lions-dashboard/artifacts/va1neofl_Maribel%20Mesina-Geib.JPG",
    linkedin: null,
    bio: [
      "My name is Maribel Mesina-Geib, and I am a Bilingual, Registered Mental Health Counselor Intern in the state of Florida. I have been working as a mental health practitioner for the last 8 years in Washington State, California, and Florida, specifically serving families, adults, children, adolescents, and couples. I completed my bachelor's degree from the University of California Irvine, double majoring in Sociology and Chicano Latino Studies. I completed my master's degree in Counseling Psychology from Northwest University in Kirkland, Washington. I have worked with a variety of individuals who experience severe/persistent mental illness, mood disorders, personality disorders, anxiety disorders, depressive disorders, self-esteem issues and substance abuse issues. I utilize a blend of Cognitive Behavioral Therapy (CBT), Solution Focused Therapy (SFT), and Client Centered Therapy to support my clients. In the last 2 years I have obtained certification in Eye Movement Desensitization and Reprocessing (EMDR), which helps support individuals processing traumatic events. In addition to being a therapist I have had the opportunity in the last 2 years to be a Clinical Manager for a private practice in Cape Coral, Florida. This has allowed me the ability to develop leadership skills, support clinician's growth, and the opportunity to learn about business. I enjoy being a therapist because I feel that I am entrusted every day with the client's most valuable thoughts and feelings. It is an honor to work towards supporting clients in reaching their mental health and recovery goals."
    ]
  },
  {
    id: 4,
    name: "Anjali M. Ghafoerkhan",
    role: "Director",
    title: "MCJROTC Cadet Battalion Operations Officer",
    image: "https://customer-assets.emergentagent.com/job_69ab5d25-c287-408f-a49d-e502a7f317ab/artifacts/vx52jmd9_anjali%20ghafoerkhan.png",
    linkedin: null,
    bio: [
      "My name is Anjali M. Ghafoerkhan, I am 16 years old and the eldest of five children. I am a student in the International Baccalaureate Program (IB) where I am pursuing the full IB Diploma at my High School.",
      "I am currently ranked in the top 1% of my graduating class. I am very politically active. I have helped create Anti-Racism training for the Girl Scouts leaders and Girl Scouts in my district, helped develop social media campaigns promoting awareness for mental health issues, and aided in organizing other events along those lines. When I am not focused on school, I enjoy debating with friends, reading, and learning about other cultures.",
      "I have been a Cadet in the Marine Corps Junior Reserve Officers Training Corps Program (MCJROTC) for the past three years. Currently, I am the Cadet Battalion Operations Officer, which involves planning and managing events for my MCJROTC unit."
    ]
  }
];

const projects = [
  {
    icon: BookOpen,
    title: "Educational Series",
    description: "Comprehensive educational content focused on mental health awareness and resources for minority communities."
  },
  {
    icon: Smartphone,
    title: "Mental Health App",
    description: "A dedicated mobile application providing mental health resources tailored for minorities."
  },
  {
    icon: Gamepad2,
    title: "Social/Emotional Board Game",
    description: "An interactive board game designed to promote social and emotional learning within minority communities."
  },
  {
    icon: GraduationCap,
    title: "Social/Emotional Curriculum",
    description: "A comprehensive curriculum for teachers and students focused on social and emotional development."
  }
];

const BioModal = ({ member, isOpen, onClose }) => {
  if (!isOpen || !member) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div 
        className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors z-10"
          style={{ position: 'sticky', float: 'right', margin: '16px' }}
        >
          <X className="w-5 h-5 text-gray-600" />
        </button>

        <div className="p-8 pt-4">
          {/* Bio Content */}
          {member.bio ? (
            <div className="text-center">
              {member.bio.map((paragraph, index) => (
                <p key={index} className="text-gray-700 leading-relaxed mb-6 text-lg text-justify">
                  {paragraph}
                </p>
              ))}
              
              {/* Member Info at Bottom */}
              <div className="flex items-center justify-center gap-4 mt-8 pt-6 border-t border-gray-200">
                <img 
                  src={member.image} 
                  alt={member.name}
                  className="w-20 h-20 rounded-full object-cover border-2 border-purple-200"
                />
                <div className="text-left">
                  <h3 className="text-xl font-bold text-gray-900">{member.name}</h3>
                  <p className="text-gray-500 uppercase text-sm tracking-wide">{member.title}</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-8">
              <img 
                src={member.image} 
                alt={member.name}
                className="w-32 h-32 rounded-full object-cover border-4 border-purple-200 mx-auto mb-4"
              />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{member.name}</h3>
              <p className="text-purple-600 font-medium mb-4">{member.title || member.role}</p>
              <p className="text-gray-500">Bio coming soon...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const MentalHealthTeam = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <div className="min-h-screen">
      {/* Bio Modal */}
      <BioModal 
        member={selectedMember} 
        isOpen={!!selectedMember} 
        onClose={() => setSelectedMember(null)} 
      />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-purple-600 via-violet-600 to-indigo-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-72 h-72 bg-white rounded-full blur-3xl" />
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-pink-300 rounded-full blur-3xl" />
        </div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-purple-200 text-sm mb-6">
            <Brain className="w-4 h-4" />
            Mental Health & Education
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Mental Health and Education Team
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-purple-100">
            Dedicated to lessening stigmas, providing resources, and empowering minority communities through mental health awareness.
          </p>
        </div>
      </section>

      {/* Vision, Mission, Purpose */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {/* Vision */}
            <div className="bg-gradient-to-br from-purple-50 to-violet-50 rounded-2xl p-8 text-center border border-purple-100 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 mx-auto mb-6 bg-purple-100 rounded-full flex items-center justify-center">
                <Lightbulb className="w-8 h-8 text-purple-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h2>
              <p className="text-gray-600 leading-relaxed">
                Lessen the stigmas associated with mental health and inspire self-expression.
              </p>
            </div>

            {/* Mission */}
            <div className="bg-gradient-to-br from-violet-50 to-indigo-50 rounded-2xl p-8 text-center border border-violet-100 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 mx-auto mb-6 bg-violet-100 rounded-full flex items-center justify-center">
                <Heart className="w-8 h-8 text-violet-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h2>
              <p className="text-gray-600 leading-relaxed">
                To provide resources, support, and awareness on mental health issues within the minority community.
              </p>
            </div>

            {/* Purpose */}
            <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-2xl p-8 text-center border border-indigo-100 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 mx-auto mb-6 bg-indigo-100 rounded-full flex items-center justify-center">
                <Sparkles className="w-8 h-8 text-indigo-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Purpose</h2>
              <p className="text-gray-600 leading-relaxed text-xl font-medium">
                Encourage, Enlighten, & Empower!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-purple-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Meet Our Team</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our dedicated directors work tirelessly to bring mental health awareness and resources to those who need it most.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto">
            {mentalHealthTeam.map((member) => (
              <div 
                key={member.id} 
                className={`bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center group ${member.bio ? 'cursor-pointer' : ''}`}
                onClick={() => member.bio && setSelectedMember(member)}
              >
                <div className="relative w-32 h-32 mx-auto mb-5">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full object-cover rounded-full border-4 border-purple-200 shadow-lg group-hover:border-purple-400 transition-colors"
                  />
                </div>
                <div className="mb-4">
                  <h3 className="text-lg font-bold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-sm text-purple-600 font-medium">{member.role}</p>
                </div>
                {member.linkedin && (
                  <a 
                    href={member.linkedin} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center justify-center w-10 h-10 bg-purple-500 text-white rounded-full hover:bg-purple-600 transition-colors"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Linkedin size={18} />
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Projects</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Innovative initiatives designed to support mental health and emotional well-being in minority communities.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {projects.map((project, index) => {
              const Icon = project.icon;
              return (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-purple-50 to-violet-50 rounded-xl p-6 border border-purple-100 hover:shadow-lg transition-all duration-300 group"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-purple-200 transition-colors">
                      <Icon className="w-6 h-6 text-purple-600" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">{project.title}</h3>
                      <p className="text-gray-600 text-sm leading-relaxed">{project.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-purple-600 to-indigo-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Join Us in Making a Difference</h2>
          <p className="text-purple-100 mb-8 max-w-xl mx-auto">
            Together, we can create a supportive community that prioritizes mental health and emotional well-being.
          </p>
          <a 
            href="/register" 
            className="inline-block bg-white text-purple-700 font-semibold px-8 py-3 rounded-full hover:bg-purple-50 transition-colors"
          >
            Get Involved
          </a>
        </div>
      </section>
    </div>
  );
};

export default MentalHealthTeam;
